module.exports = __webpack_public_path__ + "static/solvert-bb66cec884ab22e4f6d4212d523b1364.png";